export type EventType = 'exam' | 'test' | 'assignment' | 'personal' | 'school';

export interface StudentEvent {
  id: string;
  user_id: string;
  subject_id: string | null;
  title: string;
  description: string | null;
  event_type: EventType;
  event_date: string;
  end_date: string | null;
  color: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface CreateEventInput {
  title: string;
  description?: string;
  event_type: EventType;
  event_date: string;
  end_date?: string;
  subject_id?: string;
  color?: string;
}

export interface UpdateEventInput {
  title?: string;
  description?: string;
  event_type?: EventType;
  event_date?: string;
  end_date?: string;
  subject_id?: string;
  color?: string;
}

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  exam: 'Exam',
  test: 'Test / Quiz',
  assignment: 'Assignment Due',
  personal: 'Personal',
  school: 'School Event',
};

export const EVENT_TYPE_COLORS: Record<EventType, string> = {
  exam: '#ef4444',
  test: '#f97316',
  assignment: '#eab308',
  personal: '#3b82f6',
  school: '#22c55e',
};
